import { render, staticRenderFns } from "./MyAccount.vue?vue&type=template&id=fd71e56e&scoped=true"
import script from "./MyAccount.vue?vue&type=script&lang=js"
export * from "./MyAccount.vue?vue&type=script&lang=js"
import style0 from "./MyAccount.vue?vue&type=style&index=0&id=fd71e56e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd71e56e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd71e56e')) {
      api.createRecord('fd71e56e', component.options)
    } else {
      api.reload('fd71e56e', component.options)
    }
    module.hot.accept("./MyAccount.vue?vue&type=template&id=fd71e56e&scoped=true", function () {
      api.rerender('fd71e56e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MyAccount/MyAccount.vue"
export default component.exports